export const CARE_TYPE_HOSPICE = "Hospice";
export const PATIENT_STATUS_ON_SERVICE = "On-Service";



// WEBPACK FOOTER //
// ./src/utils/meds-constants.ts